export default "__VITE_ASSET__8b531e09__"